import cx from "classnames";
import React from "react";

import "./BreakdownColumn.scss";

export interface IBreakdownColumnProps {
  spanColumns: number;
}

const BreakdownColumn: React.FC<
  React.PropsWithChildren<IBreakdownColumnProps>
> = (props) => (
  <div
    className={cx("c-breakdown-column", {
      [`g-col-lg-${props.spanColumns}`]: props.spanColumns,
    })}
  >
    {props.children}
  </div>
);

export default BreakdownColumn;
